import {ErrorHandler, ModuleWithProviders, NgModule} from '@angular/core';
import * as Raven from 'raven-js';
import {environment} from '../../environments/environment';



export class RavenErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    if (environment.production) {
      Raven.captureException(err);
    } else {
      throw Error(err);
    }
  }
}

@NgModule({})
export class SentryModule {
  static forRoot(sentryURI: string): ModuleWithProviders[] {
    Raven
      .config(sentryURI)
      .install();
    return [{
      ngModule: SentryModule,
      providers: [
        {
          provide: ErrorHandler,
          useClass: RavenErrorHandler
        }
      ]
    }]

  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/sentry/sentry.module.ts